/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deregisterWebAuthnCredential} from '../api'

export const useMutationDeregisterWebAuthnCredential = createReactQueryMutationHook('deregisterWebAuthnCredential', deregisterWebAuthnCredential)
